import { Stepper } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { messages } from './StepsIndicator.messages';
import { StepOneProps } from './StepsIndicator.types';

const StepsIndicator = memo<StepOneProps>((props) => {
    const { activeStep } = props;

    return (
        <Stepper activeStep={activeStep} color='blue100'>
            <Stepper.Step label={messages.general} />

            <Stepper.Step label={messages.paymentMethod} />

            <Stepper.Step label={messages.additionalDetails} />

            <Stepper.Step label={messages.preview} />
        </Stepper>
    );
});

export default StepsIndicator;
